(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__mwCardSwipe) return;
    window.__mwCardSwipe = true;

    const bind = (slideshow) => {
      if (slideshow.dataset.mwSwipeBound) return;
      const scroller = slideshow.querySelector('slideshow-slides');
      const gallery = slideshow.closest('.card-gallery');
      const dots = gallery ? gallery.querySelectorAll('.mw-swipe-dots span') : [];
      if (!scroller || !dots.length) return;
      slideshow.dataset.mwSwipeBound = '1';

      let frame;
      scroller.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const width = scroller.clientWidth || 1;
            const index = Math.round(scroller.scrollLeft / width);
            dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          });
        },
        { passive: true }
      );
    };

    const scan = (root) => {
      if (!root || !root.querySelectorAll) return;
      if (root.matches && root.matches('slideshow-component[data-mw-swipe]')) bind(root);
      root.querySelectorAll('slideshow-component[data-mw-swipe]').forEach(bind);
    };

    const start = () => {
      scan(document);
      new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) scan(node);
          });
        }
      }).observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
